import React, { createContext, useContext, useState, useEffect } from "react";

const UsuarioContext = createContext();

export const ProtectedRouteAdministrador = ({ children }) => {
    const [Token, setToken] = useState(localStorage.getItem('Token') || null);
    const [Usuario, setUsuario] = useState(JSON.parse(localStorage.getItem('Usuario')) || null);


    // Sincronizar estado con localStorage al montar
    useEffect(() => {
        const storedToken = localStorage.getItem('Token');
        const storedUsuario = localStorage.getItem('Usuario');
        setToken(storedToken);
        setUsuario(storedUsuario ? JSON.parse(storedUsuario) : null);
    }, []);

    const setInformacionEmpresa = (token) => {
        setToken(token);
        if (token) {
            localStorage.setItem('Token', token);
        } else {
            localStorage.removeItem('Token');
        }
    };

    const setInformationUsuario = (data) => {
        setUsuario(data);
        if (data) {
            localStorage.setItem('Usuario', JSON.stringify(data));
        } else {
            localStorage.removeItem('Usuario');
        }
    };



    const logout = () => {

        localStorage.removeItem("Token");
        localStorage.removeItem("Usuario");

        setToken(null);
        setUsuario(null);

        window.location.href = "/";
    };



    return (
        <UsuarioContext.Provider
            value={{
                Token,
                Usuario,
                setInformacionEmpresa,
                setInformationUsuario,
                logout,
            }}
        >
            {children}
        </UsuarioContext.Provider>
    );
};

export const useUserAdmin = () => useContext(UsuarioContext);